export const mockData = {
  hero: {
    headline: "Turn missed calls into booked appointments and predictable monthly revenue",
    subheadline: "We install a system that captures, converts, and reactivates every customer or patient opportunity—so your phone line becomes a revenue engine.",
    trustStrip: "Trusted by clinics and service businesses across the UK"
  },

  problems: [
    {
      title: "Missed calls = lost bookings",
      description: "Every unanswered call is a customer choosing your competitor"
    },
    {
      title: "No follow-up = lost customers",
      description: "Enquiries slip through the cracks without systematic follow-up"
    },
    {
      title: "No-shows = wasted capacity",
      description: "Empty appointment slots cost you thousands in lost revenue"
    }
  ],

  lostRevenue: "Most businesses are losing £10k–£50k/month without realising it.",

  solution: {
    title: "The ClyniCall Revenue Recovery System",
    pillars: [
      {
        title: "Capture every call",
        description: "24/7 AI answering ensures no opportunity is missed",
        icon: "phone-call"
      },
      {
        title: "Convert more enquiries",
        description: "Turn conversations into confirmed bookings instantly",
        icon: "trending-up"
      },
      {
        title: "Recover missed calls",
        description: "Automatic follow-up for every missed opportunity",
        icon: "rotate-ccw"
      },
      {
        title: "Reactivate past customers",
        description: "Bring back dormant customers on autopilot",
        icon: "users"
      }
    ]
  },

  caseStudies: [
    {
      industry: "Padel Centre",
      icon: "trophy",
      before: {
        points: [
          "Missed ~25% of calls during peak hours",
          "No structured follow-up"
        ]
      },
      after: {
        points: [
          "Captured 100% of inbound calls",
          "Recovered missed enquiries via SMS"
        ]
      },
      results: [
        "+38% increase in bookings",
        "+£12,600 additional monthly revenue"
      ]
    },
    {
      industry: "Dental Clinic",
      icon: "smile",
      before: {
        points: [
          "Front desk overwhelmed",
          "Lost high-intent new patient calls"
        ]
      },
      after: {
        points: [
          "Instant call answering + booking support",
          "Automated follow-ups for missed calls"
        ]
      },
      results: [
        "+27% increase in new patient bookings",
        "£18,400 additional revenue in 30 days"
      ]
    },
    {
      industry: "Medispa",
      icon: "sparkles",
      before: {
        points: [
          "Enquiries not followed up",
          "Low conversion from calls to consultations"
        ]
      },
      after: {
        points: [
          "AI-led call handling + follow-up sequences"
        ]
      },
      results: [
        "+31% increase in consultation bookings",
        "+£22,000 monthly revenue uplift"
      ]
    },
    {
      industry: "Golf Club",
      icon: "flag",
      before: {
        points: [
          "Missed membership and booking enquiries",
          "No reactivation of old members"
        ]
      },
      after: {
        points: [
          "Automated enquiry capture + re-engagement campaigns"
        ]
      },
      results: [
        "+19 new memberships in 60 days",
        "+£15,000+ additional revenue"
      ]
    },
    {
      industry: "Chiropractor",
      icon: "activity",
      before: {
        points: [
          "Missed after-hours calls",
          "High drop-off before booking"
        ]
      },
      after: {
        points: [
          "24/7 answering + automated follow-ups"
        ]
      },
      results: [
        "+25% increase in bookings",
        "+20% reduction in no-shows"
      ]
    }
  ],

  metrics: [
    {
      stat: "+20–40%",
      label: "increase in booked appointments"
    },
    {
      stat: "£10k–£50k",
      label: "monthly revenue recovery potential"
    },
    {
      stat: "10–30%",
      label: "reduction in no-shows"
    }
  ],

  howItWorks: [
    {
      step: "1",
      title: "We install the system",
      description: "Seamless integration with your existing phone and booking infrastructure"
    },
    {
      step: "2",
      title: "It captures and converts demand",
      description: "Every call is answered, every enquiry is followed up, every opportunity is tracked"
    },
    {
      step: "3",
      title: "You get more bookings and revenue",
      description: "Watch your calendar fill up and revenue grow month after month"
    }
  ],

  differentiation: {
    headline: "Most tools answer calls. We generate revenue.",
    points: [
      "Revenue-focused, not feature-focused",
      "Built for specific industries",
      "Tracks ROI, not just activity",
      "Combines calls + follow-up + reactivation"
    ]
  },

  industries: [
    {
      name: "Dentists",
      icon: "smile",
      description: "Capture new patient enquiries 24/7 and reduce appointment gaps with automated reminders"
    },
    {
      name: "Medispas",
      icon: "sparkles",
      description: "Convert consultation requests into booked treatments and reactivate past clients"
    },
    {
      name: "Chiropractors",
      icon: "activity",
      description: "Never miss an after-hours call and keep your treatment rooms fully booked"
    },
    {
      name: "Padel & Tennis Clubs",
      icon: "trophy",
      description: "Maximize court bookings during peak times and fill off-peak slots automatically"
    },
    {
      name: "Golf Clubs",
      icon: "flag",
      description: "Grow memberships and optimize tee time bookings with intelligent follow-up"
    },
    {
      name: "More",
      icon: "plus",
      description: "We work with clinics, sports facilities, and service businesses across multiple sectors"
    }
  ],

  faqs: [
    {
      question: "How quickly can you install the system?",
      answer: "Two to four weeks."
    },
    {
      question: "What ROI can I expect?",
      answer: "Our clients typically see a 20-40% increase in booked appointments within the first 60 days, translating to £10k-£50k in additional monthly revenue depending on your average transaction value and call volume."
    },
    {
      question: "What if my staff prefer to answer calls themselves?",
      answer: "The system works alongside your team, not instead of them. It handles overflow, after-hours calls, and ensures nothing slips through. Your staff focus on delivering service while we ensure every opportunity is captured."
    }
  ]
};

export const submitContactForm = (formData) => {
  // Mock form submission
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Form submitted:', formData);
      resolve({ success: true, message: 'Thank you! We\'ll be in touch within 24 hours.' });
    }, 1000);
  });
};
